import { NoopScrollStrategy } from '@angular/cdk/overlay';
import { Component, HostListener, Input, NgZone, OnInit, ElementRef, AfterViewInit,ViewChild,Output,EventEmitter } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { InviteEarnService } from '@app-services/invite-earn/invite-earn.service';
import { UserService } from '@app-services/user/user.service';
import { ClassService } from 'src/app/core/services/class.service';
import { EventHandlingService } from 'src/app/core/services/event-handling.service';
import { FeedbackDialogComponent } from '../live-class-dialog/feedback-dialog/feedback-dialog.component';
import { ClassModel } from '@app-models/class';
import { environment } from '@app-environments/environment';
import * as moment from 'moment';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  selector: 'app-yt-videoplayer',
  templateUrl: './yt-videoplayer.component.html',
  styleUrls: ['./yt-videoplayer.component.css']
})
export class YtVideoplayerComponent implements OnInit {
  @HostListener('window:CustomEvent', ['$event']) 
  @ViewChild('iframe') iframeYt: ElementRef<HTMLIFrameElement>;
  videoStatus:any = -1;
  iframe:any;
  currentTime:any = 0;

  urlSafe : SafeResourceUrl;
  classDetails : any;
  showPlayPauseBtns:boolean = false;
  YYRRRplayer;
  firstChange:boolean = true;
  rewatchDataObj = {
    "platform": "Web",
    "startTime": 1672654729,
    "endTime": 1672654744,
    "startedAt": 1672654729,
    "endedAt": 1672654729,
    "watchedTill": 123
  }
  youtubeObject:any;
  // private player: YouTubePlayer;
  videoFullscreenStatus: boolean = false;

  @Input() ytLink:any;
  @Output() parentFucn: EventEmitter<any> = new EventEmitter();
  constructor(
    public sanitizer: DomSanitizer, 
    public router:Router, 
    private classService: ClassService,  
    private dialog: MatDialog, 
    private userService: UserService,    
    private ngZone: NgZone,  
    private _inviteNdEarn:InviteEarnService,
    private _eventHandlingService:EventHandlingService,
    private deviceService: DeviceDetectorService,) { }


  ngOnInit(): void {
    const lsYtLink =this.ytLink;
    const urlParams = new URL(lsYtLink).searchParams;
    this.iframe = document.getElementById('iframe-id');
    this.iframe.setAttribute('donotallowfullscreen', '');
    const ytUrl = urlParams.get('v')
    this.urlSafe= this.sanitizer.bypassSecurityTrustResourceUrl('https://www.youtube.com/embed/'+ytUrl+'?autoplay=1&enablejsapi=1&modestbranding=1');
    const ytSettings = localStorage.getItem('ytSettings');
    if(!(ytSettings && ytSettings == 'true')){
      window['angularComponentReference'] = { component: this, zone: this.ngZone, loadAngularFunction: (event,time,videoEnded) => this.angularFunctionCalled(event,time,videoEnded), };  
      var tag = document.createElement('script');
      tag.src = "https://www.youtube.com/iframe_api";
      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag,firstScriptTag)
      localStorage.setItem('ytSettings', 'true');
    }else{
      window.location.reload();
    }
    // window['onYouTubeIframeAPIReady'] = async () => {
    //   this.YYRRRplayer = await new window['YT'].Player('frame-id', {
    //     videoId: ytUrl,
    //     // height: playerHeight,
    //     // width: 100,
    //     playerVars: { 'autoplay': 1 },
    //     events: {
    //       'onReady': this.onPlayerReady.bind(this),
    //       'onStateChange': this.onPlayerStateChange.bind(this),
    //       'onApiChange' : ()=>{console.log('sdsddsd');
    //       }
    //     }
    //   });
    //   this.angularFunctionCalled(1);
    // };
    this.rewatchDataObj.startTime = moment().unix();
    setTimeout(() => {
      this.rewatchDataObj.startedAt = this.currentTime;
    }, 200);
    
  }

  angularFunctionCalled(data,time,videoEnded){
    this.youtubeObject = {videoEnded:videoEnded,rewatchDataObj:this.rewatchDataObj}
    this.videoStatus = data;
    this.currentTime = time;
    this.currentTime = parseFloat(this.currentTime);
    this.dispatchTasks(this.youtubeObject);
    console.log(this.youtubeObject);
    console.log(videoEnded);
  }

  dispatchTasks(obj){
    this.rewatchDataObj.endTime = moment().unix();
    this.parentFucn.emit(obj);
    this.rewatchDataObj.endedAt = this.currentTime;
    this.rewatchDataObj.watchedTill = this.currentTime;
  }
  

  seekTo(seekValue){
    (<any>window)?.seekVideo(seekValue)?.call &&  (<any>window)?.seekVideo(seekValue);
  }

  playVideo(){
    //@ts-ignore
    window?.playVideo?.call && window?.playVideo();
    // this.YYRRRplayer.playVideo();
    // this.videoStatus = 1;
  }
  pauseVideo(){
    //@ts-ignore
    // this.YYRRRplayer.pauseVideo();
    // this.videoStatus = 2;
    window?.pauseVideo?.call && window?.pauseVideo();
  }

  loadVideo(event){
    this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl('https://www.youtube.com/embed/'+event+'?enablejsapi=1&modestbranding=1&fs=0&rel=0');
    // setTimeout(() => {
    //   document.getElementById('videocontainer').setAttribute("style", "pointer-events:none;margin: 50px;padding-top: 100px;");
    // }, 1000);
  }

  divClick(event:any){
    if(this.videoStatus == 1){
      this.pauseVideo();
    }else if(this.videoStatus == 2 || this.videoStatus == -1){
      this.playVideo();
    }
  }

  divdblClick(event:any){
    const currentX = event.clientX;
    const offSetWidth = event.currentTarget.clientWidth;
    if(currentX < offSetWidth/2){
      this.seekTo(-10);
    }else if(currentX > offSetWidth/2){
      this.seekTo(10);
    }
    this.divClick('');
  }
  
  showFullScreen() {
    this.videoFullscreenStatus = true;
    var elem = document.getElementById("video-iframe-container");
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    }
    setTimeout(() => {
      if(this.videoStatus == 2 || this.videoStatus == -1){
        this.playVideo();
      }
    }, 200);    
  }
  exitFullScreen() {
    this.videoFullscreenStatus = false;
    if (document.exitFullscreen) {
      document.exitFullscreen();
    }
  }
  // dispatchEventStudentEndClass(){
  //   // this.classService.studentJoinLeftSession(data).subscribe((res) => console.log(res));
  // }

  // onPlayerReady(event: any): void {
  //   // Player is ready
  //   event.target.playVideo();
  // }

  // onPlayerStateChange(event: any): void {
  //   // Check for video time when the state changes
  //   this.getCurrentTime();
  //   // this.dataTrigger();
  //   if (event.data == window['YT'].PlayerState.PLAYING) {
  //     this.getCurrentTime();
  //   }
  //   this.rewatchDataObj.endTime = moment().unix();
  //   this.parentFucn.emit(this.rewatchDataObj);
  // }

  // getCurrentTime(): void {
  //   // Get the current time of the video
  //   this.currentTime = Math.fround(this.YYRRRplayer.getCurrentTime()).toFixed(2);
  //   this.currentTime = parseFloat(this.currentTime);
  //   console.log(this.currentTime);
  //   this.rewatchDataObj.endedAt = this.currentTime;
  //   this.rewatchDataObj.watchedTill = this.currentTime;
    
    
  // }


  ngOnChanges(): void {
  setInterval( ()=>{
    if(!this.youtubeObject?.videoEnded){
    this.parentFucn.emit(this.youtubeObject);
    }
  }, 1000);
  }
  ngOnDestroy(): void {
  }

  videoFullscreenCheck(){
    const isMobile = this.deviceService.isMobile();
    //console.log(isMobile);
    if (window.innerWidth >= 991){
      if (window.innerHeight == screen.height) {
        // browser is fullscreen
        this.videoFullscreenStatus = true;
      } else {
        this.videoFullscreenStatus = false;
      }
    }else{
      if (window.innerHeight == document.getElementById("video-iframe-container").offsetHeight) {
        // browser is fullscreen
        this.videoFullscreenStatus = true;
      } else {
        this.videoFullscreenStatus = false;
      }
    }  
  }

  ngAfterViewInit() {
    setInterval(() => { this.videoFullscreenCheck() }, 500);
  }
}

